<template>
    <div>
        <div class="btn-wrap">
                <div class="btn-list">
                    <a-button type="primary" @click="openAdd"><template #icon><plus-outlined /></template>添加套餐</a-button>
                    <a-button type="danger" @click="delMore"><template #icon><delete-outlined /></template>删除</a-button>
                </div>
                <div>
                    <a-input-group compact>
                        <a-input v-model:value="search"  placeholder="请输入套餐名称"/>
                        <a-button type="primary" @click="toSearch">搜索</a-button>
                    </a-input-group>
                </div>
            </div>

            <a-table row-key="id" :pagination="false" :columns="columns" :data-source="dataList.arr" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">
                <template #bodyCell="{ column,record}">
                    <template v-if="column.dataIndex === 'term_validity'">
                        <span v-if="record.term_validity_unit=='w'">{{record.term_validity}}周</span>
                        <span v-if="record.term_validity_unit=='s'">{{record.term_validity}}秒</span>
                        <span v-if="record.term_validity_unit=='i'">{{record.term_validity}}分</span>
                        <span v-if="record.term_validity_unit=='h'">{{record.term_validity}}时</span>
                        <span v-if="record.term_validity_unit=='d'">{{record.term_validity}}日</span>
                        <span v-if="record.term_validity_unit=='m'">{{record.term_validity}}月</span>
                        <span v-if="record.term_validity_unit=='y'">{{record.term_validity}}年</span>
                    </template>

                    <template v-if="column.dataIndex === 'total_no'">
                        {{record.total_no}} {{record.unit}}
                    </template>

                    <template v-if="column.dataIndex === 'operation'">
                        <a-button type="link" @click="openEdit(record.id)">编辑</a-button>
                        <a-button type="link" @click="del(record.id)">删除</a-button>
                    </template>
                </template>
            </a-table>

            <a-pagination
                v-model:pageSize="page.pageSize"
                show-size-changer
                :total="page.total"
                @change="pageChange"
                :show-total="total => `共 ${total} 条数据`"
            />

        <!-- 添加、编辑账户 -->
        <a-modal v-model:visible="visible" :title="title" @ok="handleOk" >
            <!-- <div style="width:390px"> -->
                <a-form
                    :model="formData.data"
                    :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }"
                    autocomplete="off"
                >
                    <a-form-item label="标题" name="title" >
                        <a-input placeholder="标题" v-model:value="formData.data.title" />
                    </a-form-item>

                    <a-form-item label="套餐数量" name="total_no" >
                        <a-input placeholder="套餐数量"  v-model:value="formData.data.total_no" />
                    </a-form-item>

                    <a-form-item label="计费单位" name="unit" >
                        <a-input placeholder="计费单位，示例值：条/分钟" v-model:value="formData.data.unit" />
                    </a-form-item>
                    <a-form-item label="总价" name="total_price" >
                        <a-input placeholder="总价" type="number" v-model:value="formData.data.total_price" />
                    </a-form-item>
                    <a-form-item label="市场价" name="original_price" >
                        <a-input placeholder="市场价" type="number" v-model:value="formData.data.original_price" />
                    </a-form-item>
                
                    <a-form-item label="有效期" >
                        <a-input-group compact>
                            <a-input  type="number" placeholder="有效期" v-model:value="formData.data.term_validity" style="width: 50%" />
                            <a-select  v-model:value="formData.data.term_validity_unit">
                                <a-select-option value="s">秒</a-select-option>
                                <a-select-option value="i">分</a-select-option>
                                <a-select-option value="h">时</a-select-option>
                                <a-select-option value="d">日</a-select-option>
                                <a-select-option value="w">周</a-select-option>
                                <a-select-option value="m">月</a-select-option>
                                <a-select-option value="y">年</a-select-option>
                            </a-select>
                        </a-input-group>
                    </a-form-item>
                    <a-form-item label="描述" name="describes" >
                        <a-textarea v-model:value="formData.data.describes" placeholder="描述" :rows="4" />
                    </a-form-item>
                    <a-form-item label="排序" name="sort" >
                        <a-input placeholder="排序"  v-model:value="formData.data.sort" />
                    </a-form-item>
                </a-form>
            <!-- </div> -->
             
        </a-modal>
    </div>
</template>

<script>
import { reactive,ref } from 'vue';
import {ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { getCurrentInstance ,createVNode} from 'vue'
import { message,Modal} from 'ant-design-vue';
const columns = [
    {title: 'ID',dataIndex: 'id',width:90},
    {title: '标题',dataIndex: 'title'},
    {title: '套餐数量',dataIndex: 'total_no'},
    {title: '总价',dataIndex: 'total_price'},
    {title: '市场价',dataIndex: 'original_price'},
    {title: '有效期',dataIndex: 'term_validity',width:130},
    {title: '描述',dataIndex: 'describes',width:230},
    {title: '排序',dataIndex: 'sort',width:80},
    {title: '添加时间',dataIndex: 'create_time'},
    {title: '操作',dataIndex: 'operation',width:180}
];
export default {
    setup(){
        const { proxy } = getCurrentInstance()
        let dataList=reactive({arr:[]})
        
        let page=reactive({page:"",pageSize:"10",total:"20"})//分页

        // 搜索
        let search=ref()
        let toSearch=function(){
            page.page="1"
            getTabledata()
        }



        // 列表
         let getTabledata=function(){
            proxy.$http.post('/admin/setmeallist',{page:page.page,pagesize:page.pageSize,search:search.value},{
                headers:{
                    'token':sessionStorage.getItem("token")
                }
            }).then((res) => {
                if(res.data.status==200){
                    dataList.arr=res.data.data.data
                    page.total=res.data.data.total
                }else{
                    message.error(res.data.msg);
                }
            });
        }
        getTabledata()

        // 添加、编辑
        let formData=reactive({data:{title:"",unit:"",total_no:"",total_price:"",term_validity:"",describes:"",sort:"",term_validity_unit:"",original_price:""}})
        let title=ref("")
        let visible=ref(false)
        let openAdd=function(){
            formData.data.title=""
            formData.data.unit=""
            formData.data.total_no=""
            formData.data.total_price=""
            formData.data.term_validity=""
            formData.data.describes=""
            formData.data.sort=""
            formData.data.original_price=""
            formData.data.term_validity_unit=""
            title.value="添加套餐"
            visible.value=true
        }

        let openEdit=function(id){
            proxy.$http.post('/admin/setmealpage',{id:id},{
                headers:{
                    'token':sessionStorage.getItem("token")
                }
            }).then((res) => {
                if(res.data.status==200){
                    visible.value=true
                    title.value="编辑套餐"
                    formData.data=res.data.data.data
                }else{
                    message.error(res.data.msg);
                }
            });
        }

        let handleOk=function(){

            if(title.value=="添加套餐"){
               
                proxy.$http.post('/admin/addsetmeal',{title:formData.data.title,unit:formData.data.unit,total_no:formData.data.total_no,
                total_price:formData.data.total_price,term_validity:formData.data.term_validity,describes:formData.data.describes,sort:formData.data.sort,
                term_validity_unit:formData.data.term_validity_unit,original_price:formData.data.original_price
                },{
                    headers:{
                        'token':sessionStorage.getItem("token")
                    }
                }).then((res) => {
                    if(res.data.status==200){
                        visible.value=false
                        message.success(res.data.msg)
                        getTabledata()
                    }else{
                        message.error(res.data.msg);
                    }
                });
                
                
            }else if(title.value=="编辑套餐"){
                proxy.$http.post('/admin/updatesetmeal',{id:formData.data.id,title:formData.data.title,unit:formData.data.unit,total_no:formData.data.total_no,
                total_price:formData.data.total_price,term_validity:formData.data.term_validity,describes:formData.data.describes,sort:formData.data.sort,
                term_validity_unit:formData.data.term_validity_unit,original_price:formData.data.original_price
                },{
                    headers:{
                        'token':sessionStorage.getItem("token")
                    }
                }).then((res) => {
                    if(res.data.status==200){
                        visible.value=false
                        message.success(res.data.msg)
                        getTabledata()
                    }else{
                        message.error(res.data.msg);
                    }
                });
            }
        }
        // 多选
        let selectedRowKeys=ref()
        let onSelectChange=function(selected) {
            selectedRowKeys.value = selected;
        }

         // 删除
        let delMore=function(){
            var id=selectedRowKeys.value.join(",")
            del(id)
        }
        let del=function(id){
            Modal.confirm({
                title: '你确定要删除吗？',
                icon: createVNode(ExclamationCircleOutlined),
            onOk() {
                proxy.$http.post('/admin/delsetmeal',{ids:id},{
                    headers:{
                        'token':sessionStorage.getItem("token")
                    }
                }).then((res) => {
                    if(res.data.status==200){
                        message.success(res.data.msg)
                        getTabledata()
                    }else{
                        message.error(res.data.msg);
                    }
                });
            },
            onCancel() {
             console.log('Cancel');
            }
            })
            
        }



        // 分页
        let pageChange=function(current, size){
            page.pageSize=size
            page.page=current
            getTabledata()
        }
        return{
            toSearch,search,
            visible,formData,openAdd,title,handleOk,openEdit,
            onSelectChange,delMore,del,selectedRowKeys,
            columns,dataList,pageChange,page
        }
    }
}
</script>